import { gql } from '@/__generated__';

export const GET_AFTER_UPDATE_DGA_TASKS = gql(`#graphql
  query DeviceConfiguration_GetAfterUpdateDGATasks($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      dga {
        id
        configuration {
          id
          enabled
        }
      }
    }
  }
`);

export const GET_AFTER_UPDATE_ALERT_TASKS = gql(`#graphql
  query DeviceConfiguration_GetAfterUpdateAlertTasks($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      alerts {
        id
        activeConfigurations {
          id
        }
      }
    }
  }
`);
